import axios from 'axios';
import { IPromisCollection } from 'entities/Promis/Promis.models';

const basePath = 'patient-metrics';

export const promisTransport = {
  getPromisCollection: (patientId: string): Promise<IPromisCollection> => axios.get(`${basePath}/${patientId}/promis`),
};
